import { render, staticRenderFns } from "./OrganisationTab.vue?vue&type=template&id=5f0d3cca&"
import script from "./OrganisationTab.vue?vue&type=script&lang=js&"
export * from "./OrganisationTab.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationTab.vue?vue&type=style&index=0&id=5f0d3cca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports